<base-index-page 
    [config]="baseIndexPageConfig"
    [service]="itemsService"
    [idKey]="'itemId'"
/>